var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomSelectComponent',{attrs:{"value":_vm.value,"add-class":"mb-3","options":_vm.distanceOption,"placeholder":"Estimasi jarak anda ke peristiwa"},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }